import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const Content = styled.div`
  transition: all 0.3s;
`;

export const ContentItemWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${themes.colors.border};
  padding: 10px 5px;
  @media ${device.desktop} {
    padding: 20px;
  }

  &:last-child {
    border: none;
  }
`;

export const ModelName = styled.h3`
  margin: 10px;
  padding: 5px;
  line-height: 1.5;
  font-size: ${themes.textSize.m1};
  color: ${themes.colors.text};
  @media ${device.tablet} {
    padding: 15px;
    font-size: ${themes.textSize.m2};
  }
  @media ${device.desktop} {
    padding: 20px;
    font-size: ${themes.textSize.m3};
  }
`;

export const SpecWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: end;
  gap: 8px;
`;

export const SpecLabel = styled.div`
  margin: 5px;
  padding: 5px;
  font-size: ${themes.textSize.s3};
  color: ${themes.colors.text};
  border: 1px solid ${themes.colors.border};
  border-radius: 10px;
  width: fit-content;
  cursor: pointer;
  width: 55px;
  text-align: center;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m1};
    width: 60px;
  }
  @media ${device.desktop} {
    margin: 10px;
    padding: 10px;
    font-size: ${themes.textSize.m2};
    width: 65px;
  }
  &:hover {
    background-color: ${themes.colors.gray200};
  }
`;
